/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefUserData } from '../../models/api-def-user-data';

export interface UsersGetUserById$Params {

/**
 * The user ID
 */
  id: string;
}

export function usersGetUserById(http: HttpClient, rootUrl: string, params: UsersGetUserById$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefUserData>> {
  const rb = new RequestBuilder(rootUrl, usersGetUserById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiDefUserData>;
    })
  );
}

usersGetUserById.PATH = '/users/{id}';
